module.exports = __webpack_public_path__ + "img/th.cd47b6a4.svg";